// ============================================================
//  PATHWAVE INTERNATIONAL — ALL SITE CONTENT
//  Edit this file to change any text on the website
// ============================================================

export const NAV_LINKS = [
  { path: '/',             label: 'Home' },
  { path: '/destinations', label: 'Destinations' },
  { path: '/about',        label: 'About' },
  { path: '/blog',         label: 'Blog' },
  { path: '/contact',      label: 'Contact' },
];

export const STATS = [
  { num: '5000+', label: 'Students Placed' },
  { num: '95%',   label: 'Visa Success Rate' },
  { num: '300+',  label: 'Partner Universities' },
];

export const SERVICES = [
  { icon: '◈', title: 'University Admissions', desc: 'End-to-end guidance from shortlisting programs to celebrating your offer letter.' },
  { icon: '⬡', title: 'Profile Building', desc: 'Strategic advice on academics and extracurriculars that make your application stand out.' },
  { icon: '◇', title: 'SOP & Essay Coaching', desc: 'Expert-crafted Statements of Purpose and essays that authentically capture your story.' },
  { icon: '⬙', title: 'Visa Assistance', desc: 'Complete student visa support — documents, interview coaching, and embassy guidance.' },
  { icon: '◈', title: 'Scholarship Guidance', desc: 'We identify and help you apply for scholarships that make your dream education affordable.' },
  { icon: '◇', title: 'Pre-Departure Support', desc: 'Accommodation, banking, travel prep, and arrival orientation before you board.' },
];

export const WHY_CHOOSE_US = [
  { num: '01', title: 'Former Admissions Officers', desc: 'Our counsellors have worked inside the very universities you are applying to. We know exactly what committees look for.' },
  { num: '02', title: 'Personalised, Not Templated', desc: 'No copy-paste strategies. Every student gets a fully custom roadmap built around their profile, goals, and budget.' },
  { num: '03', title: '95% Visa Success Rate', desc: 'Our meticulous documentation and interview coaching gives our students one of the highest visa approval rates in the industry.' },
  { num: '04', title: 'End-to-End Support', desc: 'From your first call to landing in your new country — PathWave is your guide, advocate, and partner throughout.' },
  { num: '05', title: '300+ University Partners', desc: 'Direct relationships with top institutions across the UK, USA, Canada, Australia, and Europe give our students a real edge.' },
  { num: '06', title: 'Scholarship Access', desc: 'We actively source and match students with scholarships, grants, and bursaries — many students receive partial or full funding.' },
];

export const DESTINATIONS = [
  {
    flag: '🇬🇧', tag: 'United Kingdom', title: 'Study in the UK',
    desc: 'Home to Oxford, Cambridge, Imperial, and over 130 universities — world-class degrees and a 2-year post-study work visa.',
    features: ['Russell Group & Top-Ranked Universities', 'Graduate Route Visa — 2 Years', 'IELTS / Duolingo / PTE Accepted', 'Scholarships Up to 100% Tuition'],
  },
  {
    flag: '🇺🇸', tag: 'United States', title: 'Study in the USA',
    desc: 'The most diverse higher education system in the world — Ivy League to leading state universities.',
    features: ['Ivy League & Top-50 Universities', 'OPT & STEM Extension Up to 3 Years', 'SAT / ACT / Duolingo Accepted', 'Full F-1 Student Visa Support'],
  },
  {
    flag: '🇨🇦', tag: 'Canada', title: 'Study in Canada',
    desc: 'Academic excellence and one of the most accessible pathways to permanent residency for international graduates.',
    features: ['U of Toronto, UBC, McGill & More', 'Post-Graduation Work Permit Up to 3 Yrs', 'Clear PR Pathways via Express Entry', 'Safe, Multicultural Cities'],
  },
  {
    flag: '🇦🇺', tag: 'Australia ', title: 'Australia ',
    desc: "Australia's universities are globally recognised and offer generous post-study work opportunities for international students.",
    features: ['Group of Eight Australia', 'Post-Study Work Visa Up to 4 Yrs', 'IELTS / PTE / Duolingo Accepted', 'Scholarships & Bursaries Available'],
  },
  {
    flag: '🇪🇺', tag: 'Europe', title: 'Study in Europe',
    desc: 'From Germany to the Netherlands, Europe offers world-class education, low tuition fees, and vibrant cultural experiences.',
    features: ['TU9 & Top European Universities', 'Post-Study Work Visas Vary by Country', 'IELTS / Duolingo / Local Language Accepted', 'Affordable Tuition & Living Costs'],
  },
  {
    flag: '🇳🇿', tag: 'New Zealand', title: 'Study in New Zealand',
    desc: 'A world-class education system with a strong focus on research and innovation.',
    features: ['University of Auckland', 'University of Otago', 'Massey University', 'Wellington College'],
  },
  {
    flag: '🇸🇬', tag: 'Singapore', title: 'Study in Singapore',
    desc: 'A vibrant hub for international education with world-class universities and a multicultural environment.',
    features: ['National University of Singapore', 'Nanyang Technological University', 'Singapore Management University', 'Temasek Polytechnic'],
  },
];

export const TESTIMONIALS = [
  { quote: 'PathWave made my dream of studying at the University of Toronto a reality. Their SOP coaching was exceptional.', name: 'Ananya Sharma', role: 'MSc Computer Science, University of Toronto', initial: 'A' },
  { quote: 'PathWave mapped my entire journey and I got into my first-choice university at Warwick. Life-changing support.', name: 'Rohan Mehta', role: 'BBA Finance, University of Warwick', initial: 'R' },
  { quote: 'The scholarship guidance from PathWave saved my family thousands. Truly outstanding counselling team.', name: 'Fatima Al-Rashidi', role: 'LLM Law, University of Edinburgh', initial: 'F' },
  { quote: 'I never thought I could get into a top-50 US university. PathWave believed in me and made it happen.', name: 'Karan Patel', role: 'BSc Data Science, Purdue University', initial: 'K' },
  { quote: 'The visa process felt daunting but PathWave handled everything seamlessly. Got my visa in 3 weeks!', name: 'Zara Ahmed', role: 'MBA, University of Melbourne', initial: 'Z' },
];

export const TEAM = [
  { name: 'Samira Khanna', role: 'Founder & Chief Counsellor', bio: 'Former admissions officer with 15+ years guiding students to universities across the UK, USA, Canada, and Europe.', initial: 'SK' },
  { name: 'David Osei', role: 'Head of UK & Europe', bio: 'Oxford alumnus and certified education counsellor with deep networks across Russell Group and European institutions.', initial: 'DO' },
  { name: 'Priya Nair', role: 'Head of USA & Canada', bio: 'Former international student advisor at UCLA, specialising in Ivy League and top-50 US and Canadian admissions.', initial: 'PN' },
];

// Universities for the scroll ticker — add or remove as needed
export const PARTNER_UNIVERSITIES = [
  'University of Oxford', 'Harvard University', 'University of Toronto', 'MIT',
  'Imperial College London', 'University of Melbourne', 'McGill University', 'Stanford University',
  'University of Cambridge', 'University of British Columbia', 'LSE', 'NYU',
  'University of Edinburgh', 'University of Sydney', 'Monash University', 'UCLA',
  'University of Warwick', 'TU Munich', 'Sciences Po', 'University of Amsterdam',
  'King\'s College London', 'University of Auckland', 'Purdue University', 'University College Dublin',
  'University of Glasgow', 'University of Waterloo', 'Georgetown University', 'Maastricht University',
];

export const BLOG_POSTS = [
  {
    slug: 'uk-graduate-route-visa-2026',
    tag: 'United Kingdom',
    title: 'Everything You Need to Know About the UK Graduate Route Visa',
    excerpt: 'The UK Graduate Route visa allows international students to stay and work in the UK for 2 years after completing their degree. A complete guide to eligibility and application.',
    date: 'March 10, 2026',
    readTime: '6 min read',
    author: 'David Osei',
    content: `The UK Graduate Route visa is one of the most valuable benefits of studying in the United Kingdom. It allows international students who have completed a UK degree to remain in the country for two years to work or look for work at any skill level.

## Who is Eligible?

To qualify for the Graduate Route visa, you must have successfully completed a degree at a UK-licensed student sponsor, held a valid Student visa when you apply, and be in the UK when you apply.

## How to Apply

Applications are made online through the UK Visas and Immigration portal. The fee is currently £822 and most applicants receive a decision within 8 weeks.

## What Can You Do on This Visa?

The Graduate Route gives you full flexibility to work in almost any role at any salary level, switch employers freely, and even start your own business. It is an excellent springboard to a Skilled Worker visa if you receive a qualifying job offer.

## PathWave Tips

Apply at least 60 days before your Student visa expires. Make sure your university has confirmed your award before you apply and keep digital copies of all supporting documents.`,
  },
  {
    slug: 'canada-express-entry-students',
    tag: 'Canada',
    title: 'How International Students Can Use Canada Express Entry for PR',
    excerpt: 'Canada offers one of the clearest pathways from student to permanent resident. Here is how Express Entry and the Post-Graduation Work Permit can set you up for life in Canada.',
    date: 'February 28, 2026',
    readTime: '8 min read',
    author: 'Priya Nair',
    content: `Canada is consistently ranked among the top study destinations for international students — not just for its world-class universities, but for the extraordinary opportunities it offers after graduation.

## Step 1: The Post-Graduation Work Permit

After completing a full-time program of at least 8 months at a Designated Learning Institution, you are eligible for a Post-Graduation Work Permit. The duration matches your study period — up to 3 years for programs of 2 years or longer.

## Step 2: Building Your Express Entry Profile

The Express Entry system manages applications for federal immigration programs. To qualify for the Canadian Experience Class, you typically need at least 1 year of skilled work experience in Canada.

## Step 3: Receiving an Invitation to Apply

Express Entry operates on a points system called the Comprehensive Ranking System. Candidates above a certain cut-off receive an Invitation to Apply for permanent residence.

## PathWave Advice

Choose your program and institution carefully to maximise your PGWP eligibility and CRS score. Provincial Nominee Programs can also significantly boost your points.`,
  },
  {
    slug: 'how-to-write-a-winning-sop',
    tag: 'Admissions',
    title: 'How to Write a Statement of Purpose That Gets You In',
    excerpt: 'Your Statement of Purpose is often the deciding factor between two equally qualified candidates. Our expert coaches share the exact framework we use with every PathWave student.',
    date: 'February 14, 2026',
    readTime: '10 min read',
    author: 'Samira Khanna',
    content: `At PathWave International, we have reviewed thousands of Statements of Purpose. Here is our proven framework for writing one that wins offers.

## The Three Things Every SOP Must Do

Every strong SOP tells a coherent story, demonstrates genuine fit with the program, and is written in the applicant's own authentic voice.

## Our SOP Framework

**Paragraph 1 — The Hook:** Open with a specific moment or experience that sparked your academic journey. Avoid clichés like "Since childhood I have been passionate about..."

**Paragraphs 2 and 3 — Your Journey:** Walk through your most relevant academic and professional experiences. Do not list your CV — contextualise your most important moments.

**Paragraph 4 — Why This Program:** Name specific professors, labs, or courses at the university and explain precisely why this institution is the best place for your goals.

**Paragraph 5 — Your Future:** Describe what you plan to do after the program and how this degree is an essential step in that journey.

## Common Mistakes

Starting with a dictionary definition, writing more than 1,000 words when not asked, being vague about career goals, and focusing too much on past grades rather than future potential.`,
  },
];

export const CONTACT_INFO = [
  { label: 'Headquarters',        value: 'PathWave International\nNew Delhi, India' },
  { label: 'Counselling Offices', value: 'Delhi' },
  { label: 'Email',               value: 'info@pathwaveinternational.com' },
  { label: 'Phone',               value: '+91 96500 69340' },
  { label: 'WhatsApp',            value: '+91 96500 69340' },
];
